import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { useLanguage } from '../../../contexts/LanguageContext';

const SnagResolutionPanel = ({ onConfirmResolve, onCancel, updating }) => {
  const { t } = useLanguage();
  const [notes, setNotes] = useState('');

  return (
    <div className="bg-green-50 border border-green-200 rounded-lg p-5">
      <h3 className="text-base font-semibold text-green-800 mb-3 flex items-center gap-2">
        <Icon name="CheckCircle2" size={18} className="text-green-600" />
        {t('resolveSnag')}
      </h3>
      <p className="text-sm text-green-700 mb-3">{t('resolveSnagPrompt')}</p>
      <textarea
        value={notes}
        onChange={e => setNotes(e?.target?.value)}
        placeholder={t('resolveSnagPlaceholder')}
        rows={3}
        className="w-full px-3 py-2 text-sm bg-white border border-green-300 rounded-lg text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-green-400/30 focus:border-green-400 resize-none mb-3"
      />
      <div className="flex gap-2">
        <Button
          variant="primary"
          size="sm"
          iconName={updating ? 'Loader2' : 'CheckCircle2'}
          onClick={() => onConfirmResolve(notes)}
          disabled={updating}
          className="bg-green-600 hover:bg-green-700"
        >
          {updating ? t('resolving') : t('confirmResolved')}
        </Button>
        <Button variant="outline" size="sm" onClick={onCancel}>{t('cancel')}</Button>
      </div>
    </div>
  );
};

export default SnagResolutionPanel;
